module.exports = __webpack_public_path__ + "static/media/assets_email.24526fee.png";